import * as React from "react";
import { Input, Form } from "antd";
import { LockOutlined, UserOutlined } from "@ant-design/icons";

const RemoveDeviceForm = ({
  translate,
  username,
  password,
  onChangeUsername,
  onChangePassword,
  handleEnterPress
}: {
  translate: any;
  username: string;
  password: string;
  onChangeUsername: any;
  onChangePassword: any;
  handleEnterPress: any;
}) => {
  return (
    <Form>
      <Input
        name="user-form-username"
        prefix={<UserOutlined />}
        placeholder={translate("device_management_page.modal_username")}
        allowClear={true}
        value={username}
        onChange={(e) => onChangeUsername(e.target.value)}
        style={{ marginTop: 10, marginBottom: 10 }}
        autoFocus={true}
      />

      <Input.Password
        name="user-form-password"
        prefix={<LockOutlined />}
        placeholder={translate("device_management_page.modal_password")}
        allowClear={true}
        value={password}
        onChange={(e) => onChangePassword(e.target.value)}
        style={{ marginTop: 10, marginBottom: 10 }}
        onPressEnter={() => handleEnterPress()}
      />
    </Form>
  );
};

export default RemoveDeviceForm;
